import React, { useState } from 'react';

import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { ISectionsState } from '../../../../store/sections/store';
import { SectionFilter } from '../../../../store/sections/types';
import { StoreState } from '../../../../store/store';
import style from './SectionFilters.module.scss';
import { SectionFiltersForm } from './SectionFiltersForm';
import { SectionFiltersTable } from './SectionFiltersTable';

export interface SectionFilterProps {
  sectionFilters: SectionFilter[];
  onAddFilter: (newFilter: SectionFilter) => void;
  onDeleteFilter: (filterToDelete: SectionFilter) => void;
}

export const SectionFilters = ({
  sectionFilters,
  onAddFilter,
  onDeleteFilter,
}: SectionFilterProps) => {
  const sectionsState = useSelector<StoreState, ISectionsState>(
    (state) => state.sections
  );

  const { t } = useTranslation();

  const onAddFilterClick = (newFilter: SectionFilter) => {
    onAddFilter(newFilter);
  };

  const onDeleteFilterClick = (filterToDelete: SectionFilter) => {
    onDeleteFilter(filterToDelete);

    // const deleteFilterIndex = currentFilters.findIndex(
    //   (x) => x.webSecionFilterName === filterToDelete.webSecionFilterName
    // );
    // if (deleteFilterIndex !== -1) {
    //   const filtersAfterDelete = [...currentFilters];
    //   filtersAfterDelete.splice(deleteFilterIndex, 1);
    //   setCurrentFilters(filtersAfterDelete);
    // }
  };

  return (
    <div className={style.sectionFiltersContainer}>
      <h1 className={style.sectionTitle}>{t('Section_Filters')}</h1>
      <div className={style.sectionFiltersContent}>
        <SectionFiltersForm
          onAddFilter={onAddFilterClick}
          filterTypes={sectionsState.filterTypes}
        />
        {sectionFilters.length > 0 && (
          <SectionFiltersTable
            sectionFilters={sectionFilters}
            onDeleteFilter={onDeleteFilterClick}
          />
        )}
      </div>
    </div>
  );
};
